module.exports = __webpack_public_path__ + "static/img/bruinvis-los.66a6d28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bruinvis-los.png
// module id = IBsb
// module chunks = 0